import type { IBlogPostDto, IBlogPostResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createDeleteApi } from "@api/util/createDeleteApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IBlogPostResponse>>,
  IPathBaseParam,
  IPaginationParams
>("blogPosts");
const postApis = createPostApi<
  IApiResponse<IBlogPostResponse>,
  IPathBaseParam,
  IBlogPostDto
>("blogPosts");
const getApis = createGetApi<
  IApiResponse<IBlogPostResponse>,
  IPathByIdParam,
  object
>("blogPosts");
const patchApis = createPatchApi<
  IApiResponse<IBlogPostResponse>,
  IPathByIdParam,
  IBlogPostDto
>("blogPosts");
const deleteApis = createDeleteApi<
  IApiResponse<IBlogPostResponse>,
  IPathByIdParam
>("blogPosts");

export const blogPosts = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
};
